// Adapted from davinci-elections apps/web/src/theme/recipes/checkbox.ts @ 6e23f58
import { defineSlotRecipe } from '@chakra-ui/react'
import { checkboxAnatomy } from '@chakra-ui/react/anatomy'

export const checkbox = defineSlotRecipe({
  slots: checkboxAnatomy.keys(),
  base: {
    // The whole label is the touch target (spec Goal 7: 48 px on the member pages), also when its text fits on
    // one line.
    root: {
      minH: 'var(--ipc-control-h)',
    },
    label: {
      fontWeight: 'normal',
    },
  },
  variants: {
    variant: {
      // The empty box reaches 3:1 against the page in dark mode too (`border.input`); ticked, it is the brand colour.
      solid: { control: { borderColor: 'border.input' } },
      outline: { control: { borderColor: 'border.input' } },
    },
  },
})
